import CardArticle from './CardArticle'

export default CardArticle